module.exports = __webpack_public_path__ + "fonts/font.f6b57f3.woff2";